import 'jquery';
import * as signalR from '@microsoft/signalr';

export class NotificationHub {
    constructor(o) {
        o = typeof o !== 'undefined' ? o : {};

        this.endpoints = o.endpoints;
        this.onNewNotification = o.onNewNotification;

        if (typeof this.endpoints === 'undefined') {
            throw 'NotificationHub class called without property endpoints';
        }

        if (typeof this.endpoints.SignInUri === 'undefined') {
            throw 'NotificationHub class called without property endpoints.SignInUri';
        }
    }

    async start() {
        if (unify.currentUser.isAuthenticated === false) {
            return
        }

        this._connect();
    }

    async stop() {
        if (this.connection) {
            await this.connection.stop();
            console.log('SignalR Disconnected.');
        }
    }

    _connect() {
        let that = this;
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(
                unifyConfig.userInformation.NotificationSignalRHubUri,
                {
                    accessTokenFactory: async () => await that._fetchToken()
                }
            )
            .configureLogging(signalR.LogLevel.Information)
            .withAutomaticReconnect()
            .build();

        this.connection = connection;
        connection.on('NewNotification', that.onNewNotification);

        // Start the connection.
        connection.start();
    }

    async _fetchToken() {
        const nrRetries = 10;
        for (var i = 0; i < nrRetries; i++) {
            try {
                return await this._fetchTokenFromBackend()
            }
            catch {
                console.warn('Error: could not fetch notification token');
            }
            // wait some time before retry
            await new Promise(r => setTimeout(r, 5000 * (i + 1)));
        }
        throw ('Could not retrieve notification token from backend')
    }

    async _fetchTokenFromBackend() {
        const actionUrl = '/unify/notification/getidentitytoken?update_ttl=false';
        const options = { method: 'POST' };
        let response = await fetch(actionUrl, options);
        let data = await response.json();
        return data.token;
    }
}
